export function normalizeDomain(input: string): string {
  let d = input.trim().toLowerCase();
  d = d.replace(/^https?:\/\//, "");
  d = d.replace(/^www\./, "");
  d = d.replace(/\/+$/, "");
  return d;
}

export function isValidDomain(input: string): boolean {
  const d = normalizeDomain(input);
  return /^[a-z0-9]([a-z0-9-]*[a-z0-9])?(\.[a-z]{2,})+$/.test(d);
}

const KNOWN_DOMAINS = [
  "monarchfuneralhome.com",
  "www.monarchfuneralhome.com",
];

export function domainMatchesKnown(input: string): boolean {
  const d = normalizeDomain(input);
  return KNOWN_DOMAINS.includes(d);
}
